import React from 'react';

import { NavItem, NavLink, NavbarBrand } from 'reactstrap';
import { NavLink as Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BootswatchSelect } from 'react-bootswatch-select';
import RoleContainer from "app/shared/layout/header/role-container";

export const BrandIcon = props => (
  <div {...props} className="brand-icon">
    <img src="content/images/ainnotate_logo.png" alt="Logo" />
  </div>
);

export const Brand = () => (
  <NavbarBrand tag={Link} to="/" className="brand-logo">
    <BrandIcon />
    <span className="brand-title"></span>
    <span className="navbar-version">{VERSION}</span>
  </NavbarBrand>
);

export const Home = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className="d-flex align-items-center">
      <FontAwesomeIcon icon="home" />
      <span>Home</span>
    </NavLink>
  </NavItem>
);

export const ThemeSwitcher = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className="d-flex align-items-center">
      <span className="d-flex align-items-center">Change Theme</span>
      <BootswatchSelect version={'4.4.1'} className="form-control"/>
    </NavLink>
  </NavItem>
);

export const RoleSwitcher = () => (
  <NavItem>
    <NavLink tag={Link} to="/" className="d-flex align-items-center">
      <RoleContainer />
    </NavLink>
  </NavItem>
);
